import {
  InstallableIntegrationSchema,
  IntegrationSchema,
} from '../../definitions/schemas';
import { ReactComponent as DocuSignLogo } from '../../svg/integrations/docusign.svg';
import { ReactComponent as DynamicsLogo } from '../../svg/integrations/microsoft-dynamics.svg';
import { ReactComponent as HubSpotLogo } from '../../svg/integrations/hubspot.svg';
import { ReactComponent as PipedriveLogo } from '../../svg/integrations/pipedrive.svg';
import { ReactComponent as SalesforceLogo } from '../../svg/integrations/salesforce.svg';
import { ReactComponent as SlackLogo } from '../../svg/integrations/slack.svg';
import { ReactComponent as CDKGlobalLogo } from '../../svg/integrations/cdk-global.svg';
import { IntegrationType } from './IntegrationType';

/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/models/integration.rb
 */
export enum IntegrationProvider {
  DOCUSIGN = 'docusign',
  HUBSPOT = 'hubspot',
  MICROSOFT_DYNAMICS = 'microsoft_dynamics',
  PIPEDRIVE = 'pipedrive',
  SALESFORCE = 'salesforce',
  SLACK = 'slack',
  CDK_GLOBAL = 'cdk_global',
}

export enum IntegrationVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

export const integrationProviderNames: Record<IntegrationProvider, string> = {
  [IntegrationProvider.DOCUSIGN]: 'DocuSign',
  [IntegrationProvider.HUBSPOT]: 'HubSpot',
  [IntegrationProvider.MICROSOFT_DYNAMICS]: 'Dynamics 365',
  [IntegrationProvider.PIPEDRIVE]: 'Pipedrive',
  [IntegrationProvider.SALESFORCE]: 'Salesforce',
  [IntegrationProvider.SLACK]: 'Slack',
  [IntegrationProvider.CDK_GLOBAL]: 'CDK Global',
};

export const integrationProviderLogos: Record<
  IntegrationProvider,
  typeof DocuSignLogo
> = {
  [IntegrationProvider.DOCUSIGN]: DocuSignLogo,
  [IntegrationProvider.HUBSPOT]: HubSpotLogo,
  [IntegrationProvider.MICROSOFT_DYNAMICS]: DynamicsLogo,
  [IntegrationProvider.SALESFORCE]: SalesforceLogo,
  [IntegrationProvider.PIPEDRIVE]: PipedriveLogo,
  [IntegrationProvider.SLACK]: SlackLogo,
  [IntegrationProvider.CDK_GLOBAL]: CDKGlobalLogo,
};

export const getIntegrationInstallation = (
  provider: IntegrationProvider,
  installableIntegrations?: InstallableIntegrationSchema[]
): InstallableIntegrationSchema | undefined =>
  installableIntegrations?.find(
    ({ providerName }) => providerName === provider
  );

export const getIntegrationConnection = (
  provider: IntegrationProvider,
  installedIntegrations?: IntegrationSchema[]
): IntegrationSchema | undefined =>
  installedIntegrations?.find(({ providerName }) => providerName === provider);

export const isSignaturesIntegration = (
  integration: InstallableIntegrationSchema | IntegrationSchema
) => integration.integrationType === IntegrationType.SIGNATURES;
